import { render, staticRenderFns } from "./EditLocationServices.vue?vue&type=template&id=6b06dadf&"
import script from "./EditLocationServices.vue?vue&type=script&lang=js&"
export * from "./EditLocationServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports